import React from 'react';
import PropTypes from 'prop-types';

import DotsPlot from 'components/DotsPlot';

import TailTypeRadioButton from 'components/TailTypeRadioButton';
import SamplesSpecifications from 'components/SamplesSpecifications';

const RightPaneComponent = props =>
  <div id="right-pane" className="height-full">
    <div className="content-item">
      <div className="flex space-between">
        <p className="font-700 mb-10">
          Dot Plot of All Generated Samples
        </p>
      </div>

      <div className="text-right">
        <TailTypeRadioButton value="left" {...props.tailTypeRadioButtonProps}>
          Color Left Tail
        </TailTypeRadioButton>

        <TailTypeRadioButton value="right" {...props.tailTypeRadioButtonProps}>
          Color Right Tail
        </TailTypeRadioButton>

        <TailTypeRadioButton value="both" {...props.tailTypeRadioButtonProps}>
          Color Both Tails
        </TailTypeRadioButton>
      </div>

      <DotsPlot
        dots={props.dots}
        onDotClick={props.onDotClick}
        selectedDotId={props.selectedSample}

        leftCutoff={props.leftCutoff}
        rightCutoff={props.rightCutoff}

        yAxisLabel={`Tally of ${props.measurement}'s ${props.testSelection}`}
        xAxisLabel={`${props.testSelection} of ${props.measurement}`}
      />

      <SamplesSpecifications
        className="pl-30"

        mean={props.mean}
        meanLabel="Generated Samples Mean"

        stdev={props.stdev}
        stdevLabel="Standard Deviation of All Samples"

        amount={props.amount}
        amountLabel="Total Number of Samples"
      />
    </div>
  </div>;

RightPaneComponent.propTypes = {
  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,

  leftCutoff: PropTypes.number.isRequired,
  rightCutoff: PropTypes.number.isRequired,

  onDotClick: PropTypes.func.isRequired,

  parameterName: PropTypes.string.isRequired,
  selectedSample: PropTypes.number.isRequired,

  tailTypeRadioButtonProps: PropTypes.object.isRequired,

  testSelection: PropTypes.string.isRequired,
  measurement: PropTypes.string.isRequired,

  dots: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,

  amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired
};

export default RightPaneComponent;
